import { render } from "./Peliculas.vue?vue&type=template&id=33883c08&scoped=true"
import script from "./Peliculas.vue?vue&type=script&lang=js"
export * from "./Peliculas.vue?vue&type=script&lang=js"

import "./Peliculas.vue?vue&type=style&index=0&id=33883c08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33883c08"]])

export default __exports__